import { useState, useEffect } from 'react';
import { Textarea } from '../input';
import { paramsInputsStyle } from './shared';
import { Inner } from './Inner';

export const RunJson = (props) => {
  const [endpoint, setEndpoint] = useState();
  const [invalid, setInvalid] = useState();

  const renderChildren = (params, onChange, onSetParams, errors) => {
    const [value, setValue] = useState('');

    useEffect(() => {
      setInvalid(false);
      setEndpoint();

      if (!value) {
        return;
      }

      let obj;
      try {
        obj = JSON.parse(value);
      } catch {
        setInvalid(true);
        return;
      }

      console.log('->obj args', obj.args);
      console.log('->obj name', obj.name);

      setEndpoint(obj.name);
      onSetParams(obj.args);
      setInvalid(false);
    }, [value]);

    return (
      <div style={paramsInputsStyle}>
        <Textarea
          value={value}
          minRows={5}
          maxRows={20}
          onChange={(e) => setValue(e.target.value)}
          style={{ width: '100%', maxWidth: 600, fontFamily: 'monospace' }}
        />
        {invalid && <div style={{ fontSize: 12 }}>Must be valid JSON</div>}
      </div>
    );
  };

  return (
    <div>
      <Inner
        endpoint={endpoint}
        disabled={!endpoint || invalid}
        initialParams={props.params}
        examples={[]}
        renderChildren={renderChildren}
        {...props}
      />
    </div>
  );
};
